import IRequest from "../../IRequest";

export interface IFuncoesFinanceiras {
    reqFuncoes: IRequest<TFuncaoFinanceiro>,
    dataFuncoes: TFuncaoFinanceiro[]
  }

export type TFuncaoFinanceiro = {
  id: number;
  nome: string;
  considera_fechamento_cc: 'S' | 'N';
  considera_fluxo_caixa: 'S' | 'N';
  flg_troca_funcao: 'S' | 'N';
}

export const defValueFuncao = {
  id: 0,
  nome: '',
  considera_fechamento_cc: 'N',
  considera_fluxo_caixa: 'N',
  flg_troca_funcao: 'N',
}